module.exports = __webpack_public_path__ + "static/media/CA.48758730.png";